import React from 'react';

import Settings from '../config';
import API from '../utils/API';

class LoginForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {}
  }

  render() {
    return (
      <div>
        {
          this.state.error ? (
            <div className="alert alert-danger">
              <i className="fa fa-exclamation-triangle" /> {this.props.error}
            </div>
          ) : ''
        }

        <form className="form" method="POST" onSubmit={this.props.onSubmit}>
          <div className="form-group">
            <label html-for="email">Email:
              <input type="text" className="form-control mr-2" name="email" />
            </label>
            <br />
            <label html-for="password">Password:
              <input type="password" className="form-control mr-2" name="password" />
            </label>

            <div className="mt-2">
              <button type="submit" className="btn btn-primary"><i className="fa fa-arrow-right mr-1" /> Accedi</button>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

export default LoginForm;


// WEBPACK FOOTER //
// ./src/components/LoginForm.js